/**
 * @flow
 * @relayHash a845b4c8d21cd7e78d067245b08ea441
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PrePostMutationInput = {|
  formName: string,
  responses: $ReadOnlyArray<?Response>,
  clientMutationId?: ?string,
|};
export type Response = {|
  question: string,
  answer: string,
|};
export type InterventionSatisfactionMutationVariables = {|
  input: PrePostMutationInput
|};
export type InterventionSatisfactionMutationResponse = {|
  +prepostMutation: ?{|
    +nextForm: ?string
  |}
|};
export type InterventionSatisfactionMutation = {|
  variables: InterventionSatisfactionMutationVariables,
  response: InterventionSatisfactionMutationResponse,
|};
*/


/*
mutation InterventionSatisfactionMutation(
  $input: PrePostMutationInput!
) {
  prepostMutation(input: $input) {
    nextForm
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PrePostMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "prepostMutation",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PrePostMutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "nextForm",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "InterventionSatisfactionMutation",
    "type": "RelayMutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "InterventionSatisfactionMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "InterventionSatisfactionMutation",
    "id": null,
    "text": "mutation InterventionSatisfactionMutation(\n  $input: PrePostMutationInput!\n) {\n  prepostMutation(input: $input) {\n    nextForm\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7d26486c6201ca3e243211fa50099d2c';
module.exports = node;
